// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"78":"3045dfc97b4c6910","86":"44a2140049e4841c","187":"3fc35ea5a08267df"}[chunkId] + ".js";
};